import Masonry from 'masonry-layout';
import GLightbox from 'glightbox';

if (window.globalGallery) {
  const gallery = window.globalGallery
  let count = gallery.length
  let loaded = 0
  const spinnerCounter = document.querySelector('.page_content-galleries-counter');

  const updateCounter = () => {
    spinnerCounter.textContent = `${loaded} / ${count}`;
  }

  const loadImage = (thumb) => {
    return new Promise(resolve => {
      const img = new Image()
  
      img.onload = function() {
        if (loaded == 0) spinnerCounter.classList.remove('d-none')

        loaded++
        updateCounter()
        resolve()
      }
  
      img.src = thumb
    })
  }
  
  const promises = [];
  for (const img of gallery) {
    promises.push(loadImage(img[0]));
  }

  Promise.all(promises)
    .then(() => {
      let html = ''

      for (const img of gallery) {
        html += `<div class="page_content-galleries-item col-12 col-sm-6 col-md-6 col-lg-4"><a href="${img[1]}" data-gallery="gallery"><img src="${img[0]}" class="page_content-galleries-item-img"></a></div>`;
      }
    
      const container = document.querySelector('.page_content-galleries')

      container.classList.add('pre-render')
      container.innerHTML = html
      spinnerCounter.remove()
      
      setTimeout(() => {
        const m = new Masonry(container, {
          itemSelector: '.page_content-galleries-item'
        });
  
        const lightbox = new GLightbox({
          selector: '[data-gallery]'
        });
        lightbox.init();

        document.querySelector('.page_content-galleries-loader').remove()
        container.classList.remove('pre-render')
      }, 1000)
    })
}
